import { digObject, encodeParams } from '@domain-group/javascript-utils'
import { useLatestEntity } from '@domain-group/react-hooks'

import { BookingModel } from '@models/booking'

export const generateUrls = (booking: BookingModel) => {
  const { id } = booking || {}
  const date = digObject(booking, 'dates.start.date_time', '')

  const params = encodeParams({ booking_id: id, date })

  return { providerDashboardBookingCalendarUrl: `/admin/provider_dashboard#/booking-calendar?${params}` }
}

function useBooking(initEntity: Partial<BookingModel> = {}) {
  // @ts-expect-error TS2322
  const { entity: booking }: { entity: BookingModel} = useLatestEntity(initEntity, 'bookings')

  return {
    booking,
    urls: generateUrls(booking),
  }
}

export default useBooking
